export default __webpack_public_path__ + "static/media/Blackmarrow Leggings.da71f165.jpg";